/*
 * main
 */
import 'core-js';
import 'regenerator-runtime/runtime';

import components from './build/components.js';
import utils from './build/utils.js';

import pageDashboard from './build/page_dashboard.js';
import pageSurvey from './build/page_survey.js';
import pageOffice from './build/page_office.js';
import pageStaff from './build/page_staff.js';
import pageAccount from './build/page_account.js';

$(function(){
	/**
	 * 共有インスタンス
	 */
	const cmp = new components();
	const util = new utils();

	/**
	 * 共通処理
	 */
	// グローバルナビ::ログアウト（これだけ特殊）
	const gnavModal = cmp.modal('.btn-signout');
	$(document).click(function(ev){
//		if($(ev.target).hasClass('gnav-link') || $(ev.target).closest('.gnav-link').length) window.stop();
		if($(ev.target).attr('id') == 'btn-signout') {
			$('.btn-signout').click();
			localStorage.clear();
			return false;
		}

		ev.stopPropagation();
		return true;
	});

	 // グローバルナビ
	const gnav = cmp.gnav('#vue-gnav');

	// 下部ナビ
	cmp.bottomNav();
	// -------------------------------------------------------------

	/**
	 * ダッシュボード画面
	 * currentView.nav : global
	 */
	if(currentView.nav == 'dashboard') {
		pageDashboard(cmp, util);
		return;
	}
	// -------------------------------------------------------------

	/**
	 * アンケート管理画面
	 * currentView.nav : global
	 */
	if(currentView.nav == 'survey') {
		pageSurvey(cmp, util);
		return;
	}
	// ---------------------------------------------------------------

	/**
	 * 事業所管理画面
	 * currentView.nav : global
	 */
	if(currentView.nav == 'office') {
		pageOffice(cmp, util);
		return;
	}
	// ---------------------------------------------------------------

	/**
	 * スタッフ管理画面
	 * currentView.nav : global
	 */
	if(currentView.nav == 'staff') {
		pageStaff(cmp, util);
		return;
	}
	// ---------------------------------------------------------------

	/**
	 * アカウント管理画面
	 * currentView.nav : global
	 */
	if(currentView.nav == 'account') {
		pageAccount(cmp, util);
		return;
	}
	// ---------------------------------------------------------------
});
/*
//base
import './build/copy.js';

//component
import './build/alert.js';
import './build/list.js';

//form
import './build/form.js';

//page
import './build/e001.js';
import './build/a001.js';
*/
